import { useAtom } from "jotai";
import logger from "~/lib/logger";
import { toggleShowKnownLemmasAction } from "~/server/actions/videos/actions";

import { isShowKnownLemmasEnabledAtom } from "../state";

export function useShowKnownLemmas() {
  const [isShowKnownLemmasEnabled, setIsShowKnownLemmasEnabled] = useAtom(
    isShowKnownLemmasEnabledAtom,
  );

  const toggleShowKnownLemmas = async () => {
    try {
      const result = await toggleShowKnownLemmasAction();
      if (!result.success) {
        logger.error("Failed to toggle show known lemmas", { result });
      } else {
        setIsShowKnownLemmasEnabled(result.isShowKnownLemmasEnabled ?? false);
      }
    } catch (error) {
      logger.error("Failed to toggle show known lemmas", { error });
    }
  };

  return {
    isShowKnownLemmasEnabled,
    toggleShowKnownLemmas,
  };
}
